// Centralised icon re-exports.
//
// `@untitledui/icons` uses unintuitive numeric-suffix names (Trash01, SearchSm).
// Components import from `@/lib/icons` instead so the friendly names live in ONE
// place. Add new icons here first; never import from `@untitledui/icons` directly
// in components.
import {
  ArrowLeft as _ArrowLeft,
  Save01 as _Save,
  ArrowNarrowRight as _ArrowNarrowRight,
  ClipboardCheck as _ClipboardCheck,
  Building01 as _Building,
  CheckCircle as _CheckCircle,
  ChevronLeftDouble as _ChevronLeftDouble,
  ChevronRightDouble as _ChevronRightDouble,
  Copy01 as _Copy,
  Database01 as _Database,
  Download01 as _Download,
  Edit05 as _Edit,
  Eye as _Eye,
  Folder as _Folder,
  Image01 as _Image,
  Link01 as _Link,
  Menu01 as _Menu,
  Package as _Package,
  RefreshCw01 as _Refresh,
  SearchSm as _Search,
  Tag01 as _Tag,
  Trash01 as _Trash,
  XCircle as _XCircle,
  MessageDotsCircle as _MessageDots,
  Loading01 as _Spinner,
  Sliders01 as _Sliders,
  InfoCircle as _InfoCircle,
} from "@untitledui/icons";

export const ArrowLeft = _ArrowLeft;
export const ArrowRight = _ArrowNarrowRight;
export const ClipboardCheck = _ClipboardCheck;
export const Building = _Building;
export const Check = _CheckCircle;
export const ChevronCollapse = _ChevronLeftDouble;
export const ChevronExpand = _ChevronRightDouble;
export const Copy = _Copy;
export const Database = _Database;
export const Download = _Download;
export const Edit = _Edit;
export const Eye = _Eye;
export const Folder = _Folder;
export const Image = _Image;
export const Link = _Link;
export const Menu = _Menu;
export const Package = _Package;
export const Refresh = _Refresh;
export const Save = _Save;
export const Search = _Search;
export const Tag = _Tag;
export const Trash = _Trash;
export const X = _XCircle;
export const MessageDots = _MessageDots;
export const Spinner = _Spinner;
export const Sliders = _Sliders;
export const InfoCircle = _InfoCircle;
